/**
 * New Testimonials Section JavaScript
 * Handles Swiper carousel functionality for testimonials
 */

const swiper = new Swiper(".testimonials-swiper", {
    slidesPerView: 2,
    spaceBetween: 16,
    loop: true,
    speed: 3000,              // slow, for marquee effect
    allowTouchMove: true,      // keep manual drag (set false to lock)
    autoplay: {
      delay: 0,                // no pause between transitions
      disableOnInteraction: false,
      pauseOnMouseEnter: false
    },
    initialSlide: 1,
    watchSlidesProgress: true,
    on: {
      init(sw){
        // Transición lineal para efecto tipo marquesina (sin freeMode)
        sw.wrapperEl.style.transitionTimingFunction = 'linear';
        sw.autoplay.start();
      },
      slideChange(sw){
        // Reafirma timing linear tras cada ciclo (algunos browsers lo resetean)
        sw.wrapperEl.style.transitionTimingFunction = 'linear';
      }
    }  
  });